import APP_CONFIG from "../../app.config";
import Image from "next/image";
import React, { useState } from "react";
import { useGetFinancingQuery, Vehicle } from "../../graphql/generated/graphql";
import LoanCalculator from "./LoanForm";
import Accordion from "../Accordion";

const isEnabled = APP_CONFIG.partners.crediq.enabled;

export const LoanBanner = ({ vehicle }: { vehicle: Vehicle }) => {
  const { data } = useGetFinancingQuery({
    variables: {
      brand: vehicle.brand,
      model: vehicle.model,
      year: vehicle.year,
    },
  });

  const { getFinancing: financingData } = data || {};

  if (isEnabled && financingData) {
    return (
      <div className="mt-6 flex flex-col items-center gap-3">
        <div className="text-center">
          <p className="text-sm text-gray-700">Financiamiento disponible con</p>
          <div className="relative mt-2">
            <Image
              src="/partners/logo_crediq.png"
              alt="Bank Logo"
              height={64}
              width={220}
            />
          </div>
        </div>
        <LoanCalculator vehicle={vehicle} financingData={financingData} />
      </div>
    );
  }

  return null;
};

export const LoanBannerAccordion = ({ vehicle }: { vehicle: Vehicle }) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data } = useGetFinancingQuery({
    variables: {
      vehicleId: vehicle._id,
      brand: vehicle.brand,
      model: vehicle.model,
      year: vehicle.year,
    },
  });

  const { getFinancing: financingData } = data || {};
  if (isEnabled && financingData) {
    return (
      <div className="flex flex-col items-center gap-3">
        <div className="text-center">
          <p className="text-sm text-gray-700">Financiamiento disponible con</p>
          <div className="relative mt-2">
            <Image
              src="/partners/logo_crediq.png"
              alt="Bank Logo"
              height={64}
              width={220}
            />
          </div>
        </div>
        <Accordion
          title="Abrir cotizador de CrediQ"
          Component={
            <LoanCalculator vehicle={vehicle} financingData={financingData} />
          }
          accordionOpen={isOpen}
          setAccordionOpen={() => setIsOpen(!isOpen)}
          containerClassName="!my-2"
          buttonClassName="bg-sky-700 text-white border-t border-r border-l rounded-md pl-3 !py-3"
          iconClassName="!text-white"
        />
      </div>
    );
  }
};
